(() => {
  const LOCKED_CLASS = "page-scroll-locked";
  const MEGAMENU_ID_PATTERN = /^megamenu--/i;

  const lockOwners = new Set();
  let savedScrollY = 0;
  let savedPathname = "";

  const lockPage = () => {
    savedScrollY = window.scrollY;
    savedPathname = window.location.pathname;
    document.body.style.top = `-${savedScrollY}px`;
    document.documentElement.classList.add(LOCKED_CLASS);
  };

  const unlockPage = () => {
    document.documentElement.classList.remove(LOCKED_CLASS);
    document.body.style.top = "";
    const isSamePage = window.location.pathname === savedPathname;
    if (isSamePage) window.scrollTo({ top: savedScrollY, behavior: "instant" });
  };

  const isRemovedElement = (owner) => owner instanceof Element && !owner.isConnected;

  const removeOwner = (owner) => {
    if (!lockOwners.delete(owner)) return;
    if (lockOwners.size === 0) unlockPage();
  };

  const removeOwnersOutsidePage = () => {
    [...lockOwners].filter(isRemovedElement).forEach(removeOwner);
  };

  const lock = (owner) => {
    removeOwnersOutsidePage();
    if (lockOwners.has(owner)) return;
    lockOwners.add(owner);
    if (lockOwners.size === 1) lockPage();
  };

  const unlock = (owner) => {
    removeOwner(owner);
    removeOwnersOutsidePage();
  };

  const setLocked = (owner, shouldLock) => (shouldLock ? lock(owner) : unlock(owner));

  const getScrollY = () => (lockOwners.size ? savedScrollY : window.scrollY);

  const isModalOpen = (store) => !!store.id && !MEGAMENU_ID_PATTERN.test(store.id);
  const isStoreOpen = (store) => !!store.open;

  const storeChecks = [
    ["modal", isModalOpen],
    ["quickView", isStoreOpen],
    ["productDrawer", isStoreOpen],
    ["mediaGallery", isStoreOpen],
    ["videoGallery", isStoreOpen],
    ["backInStockNotification", isStoreOpen],
  ];

  const watchModalStores = () => {
    storeChecks.forEach(([storeName, isOpen]) => {
      const store = window.Alpine.store(storeName);
      if (!store) return;
      const owner = `store:${storeName}`;
      window.Alpine.effect(() => setLocked(owner, isOpen(store)));
    });
  };

  window.pageScrollLock = { lock, unlock, setLocked, getScrollY, watchModalStores };
})();
